import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDateTimeFormate, hideAccNo, showfirst4 } from "../../sharedfiles/helper";
import { fetchBankDetails, changePrimaryAccount, activateBank, deactivateBankAccount } from "./BankDetailSlice";
import ConfirmDialog from "../Common/Dialog/ConfirmDialog";
import { BANKDETAIL_CONSTANTS, COMMON_CONSTANTS } from "../../sharedfiles/Constants";
import NoDataFound from "../Common/table/NoDataFound";
import { BankInfo, COMMON_MSGS } from "../../sharedfiles/tooltipMsgs";
import Tooltips from "../Common/Tooltip";
import { Button } from "../../ui/button";
import { CheckCircle2, XCircle } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../ui/table";
import { useColumnPreferences } from "../../sharedfiles/hooks/useColumnPreferences";
import TableToolbar from "../Common/table/TableToolbar";
const BankDetailtable = (props) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [accountId, setAccountId] = useState("");
  const id = localStorage.getItem("userId");
  const dispatch = useDispatch();
  const { viewOnlyuser } = useSelector((state) => state.dashboard);
  const setPrimaryAccnt = (e) => {
    setAccountId(e.target.value);
    setOpenDialog(true);
  };
  const handlePrimary = () => {
    dispatch(changePrimaryAccount(id, accountId));
    setTimeout(() => {
      dispatch(fetchBankDetails({ id }));
    }, 500);
    setOpenDialog(false);
    // }
  };
  function handleBankActivate(id) {
    dispatch(activateBank(id, props.data))
  }
  function handleBankDeactivate(id) {
    dispatch(deactivateBankAccount(id, props.data))
  }

  // The table below had its 10 headers individually hardcoded rather than
  // driven by an array.
  const bankHeaders = [
    "Primary",
    BANKDETAIL_CONSTANTS.th_ahn,
    BANKDETAIL_CONSTANTS.th_bankName,
    BANKDETAIL_CONSTANTS.th_branchName,
    BANKDETAIL_CONSTANTS.th_accountNo,
    BANKDETAIL_CONSTANTS.th_ifsc,
    COMMON_CONSTANTS.createdDate,
    COMMON_CONSTANTS.updatedDate,
    COMMON_CONSTANTS.status,
    COMMON_CONSTANTS.actions,
  ];
  const bankTooltips = [
    null,
    BankInfo.ahn,
    BankInfo.bankName,
    BankInfo.branchName,
    BankInfo.accountNo,
    BankInfo.ifsc,
    COMMON_MSGS.createdDate,
    COMMON_MSGS.updatedDate,
    COMMON_MSGS.Status,
    COMMON_MSGS.Actions,
  ];
  const bankCellClassName = [
    undefined,
    "text-sm",
    "text-sm",
    "text-sm",
    "text-sm font-mono",
    "text-sm font-mono",
    "text-sm text-muted-foreground",
    "text-sm text-muted-foreground",
    undefined,
    undefined,
  ];
  const bankRowAccessors = [
    (item) => (
      <input
        type='radio'
        name='primaryAccount'
        value={item.id}
        checked={item.isPrimary}
        onChange={(e) => setPrimaryAccnt(e)}
        disabled={viewOnlyuser}
        className="w-4 h-4 cursor-pointer accent-primary"
      />
    ),
    (item) => item.accountHolderName,
    (item) => item.bankName,
    (item) => item.branchName,
    (item) => (!props.masking ? hideAccNo(item.accountNumber) : item.accountNumber),
    (item) => item.ifscCode,
    (item) => (item.createdDate ? getDateTimeFormate(item.createdDate) : "-"),
    (item) => (item.updatedAt ? getDateTimeFormate(item.updatedAt) : "-"),
    (item) => (
      item.isActive ? (
        <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-950 dark:text-green-400">
          <CheckCircle2 className="h-3 w-3" />
          ACTIVE
        </span>
      ) : (
        <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-400">
          <XCircle className="h-3 w-3" />
          INACTIVE
        </span>
      )
    ),
    (item) => (
      <div className="flex gap-2">
        <Button
          type='button'
          id='bankactivesave'
          variant={item.isActive ? "outline" : "default"}
          size="sm"
          disabled={item.isActive || viewOnlyuser}
          onClick={() => handleBankActivate(item.id)}
          className="min-w-[80px]"
        >
          {COMMON_CONSTANTS.active}
        </Button>
        <Button
          type='button'
          id='bankactivecancel'
          variant={!item.isActive ? "outline" : "destructive"}
          size="sm"
          disabled={!item.isActive || viewOnlyuser}
          onClick={() => handleBankDeactivate(item.id)}
          className="min-w-[80px]"
        >
          {COMMON_CONSTANTS.deactive}
        </Button>
      </div>
    ),
  ];
  const { visibleIndices, allColumns, toggleVisibility, reorder, resetToDefault } =
    useColumnPreferences("bankDetailsBankDetailtable", bankHeaders);

  return (
    <>
      <ConfirmDialog
        title={"Primary account"}
        message={"Do you want to change your Primary Account ?"}
        open={openDialog}
        cancel={() => setOpenDialog(false)}
        verify={handlePrimary}
        close={() => setOpenDialog(false)}
        width={"sm"}
      />
      <div className="relative rounded-lg border bg-card overflow-hidden shadow-sm">
        <TableToolbar
          columns={allColumns}
          onToggle={toggleVisibility}
          onReorder={reorder}
          onReset={resetToDefault}
        />
        <Table>
          <TableHeader>
            <TableRow>
              {visibleIndices.map((origIdx) => (
                <TableHead key={origIdx} className="whitespace-nowrap">
                  <div className='flex items-center gap-1'>
                    <span>{bankHeaders[origIdx]}</span>
                    <Tooltips info={bankTooltips[origIdx]} />
                  </div>
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>

          <TableBody>
              {props.data && Array.isArray(props.data) &&
                Object.keys(props.data).length > 0 && props.data.length > 0 ? (
                props.data.map((item, index) => {
                  return (
                    <TableRow key={`${index}_${item.accountNumber}`}>
                      {visibleIndices.map((origIdx) => (
                        <TableCell key={origIdx} className={bankCellClassName[origIdx]}>
                          {bankRowAccessors[origIdx](item)}
                        </TableCell>
                      ))}
                    </TableRow>
                  );
                })
              ) : (
                <NoDataFound colspan={visibleIndices.length} />
              )}
          </TableBody>
        </Table>
      </div>
    </>
  );
};


export default BankDetailtable;

